/* eslint-disable boundaries/element-types */
import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { RolodexEntryType } from 'types'

export const useImportInspectionData = () => {
  const { inspections, getInspection } = useRolodexEntries({
    type: [RolodexEntryType.INSPECTION],
    tags: {
      job: 'unknown',
      site: 'unknown',
      unit: 'unknown',
      component: 'unknown',
      organization: 'unknown',
    },
  })

  return useMemo(() => {
    return {
      inspections,
      getInspection,
    }
  }, [inspections, getInspection])
}
